export const DEFAULT_PERSONA_REACTION_RULES = {
  like_probability: 0.6,
  dislike_probability: 0.1,
  comment_probability: 0.2,
  reference_answer_probability: 0.1,
} as const;

export const DEFAULT_PERSONA_JUDGE_META_PROMPTS = {
  like_prompt: 'Оцени сообщение, если нравится поставь лайк',
  dislike_prompt: 'Оцени сообщение, если не нравится поставь дизлайк',
  comment_prompt: 'Оцени сообщение и прокомментируй',
  reference_answer_prompt: '',
} as const;

export type PersonaJudgeMetaPromptsForm = {
  like_prompt: string;
  dislike_prompt: string;
  comment_prompt: string;
  reference_answer_prompt: string;
};

export type PersonaFormState = {
  name: string;
  description: string;
  reaction_rules: {
    like_probability: number;
    dislike_probability: number;
    comment_probability: number;
    reference_answer_probability: number;
  };
  judge_meta_prompts: PersonaJudgeMetaPromptsForm;
};

export function createDefaultPersonaFormState(): PersonaFormState {
  return {
    name: '',
    description: '',
    reaction_rules: { ...DEFAULT_PERSONA_REACTION_RULES },
    judge_meta_prompts: { ...DEFAULT_PERSONA_JUDGE_META_PROMPTS },
  };
}

/** Fill empty judge prompts with persona defaults (create, edit, save). */
export function resolvePersonaJudgeMetaPrompts(
  prompts: Partial<PersonaJudgeMetaPromptsForm> | null | undefined
): PersonaJudgeMetaPromptsForm {
  return {
    like_prompt: prompts?.like_prompt?.trim() || DEFAULT_PERSONA_JUDGE_META_PROMPTS.like_prompt,
    dislike_prompt: prompts?.dislike_prompt?.trim() || DEFAULT_PERSONA_JUDGE_META_PROMPTS.dislike_prompt,
    comment_prompt: prompts?.comment_prompt?.trim() || DEFAULT_PERSONA_JUDGE_META_PROMPTS.comment_prompt,
    reference_answer_prompt: prompts?.reference_answer_prompt?.trim() || '',
  };
}
